import React from 'react';
import { Link } from 'react-router-dom';
import { useInView } from '../../hooks';
import { Badge } from '../ui';
import { PlatformIcon } from '../common/Icons';
import { featuredGames } from '../../data/games';

const getStatusVariant = (status) => {
  const variants = {
    'Available Now': 'available',
    'Coming Soon': 'coming-soon',
    'Beta': 'beta',
    'Early Access': 'early-access',
    'Announced': 'announced',
    'In Development': 'in-development',
  };
  return variants[status] || 'default';
};

const GameCard = ({ game, index }) => {
  const [ref, isInView] = useInView(0.1);

  return (
    <Link
      to={`/games/${game.slug}`}
      ref={ref}
      className={`card-hover group rounded-3xl overflow-hidden bg-white/5 border border-white/10 block transition-all duration-700 ${
        isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="aspect-video relative" style={{ background: game.image }}>
        <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors" />
        <div className="absolute top-4 right-4">
          <Badge variant={getStatusVariant(game.status)}>{game.status}</Badge>
        </div>
        <div className="absolute bottom-4 left-4 flex gap-2">
          {game.platforms.slice(0, 3).map((p) => (
            <div
              key={p}
              className="w-8 h-8 rounded-lg bg-black/50 backdrop-blur flex items-center justify-center text-white/80"
            >
              <PlatformIcon platform={p} className="w-4 h-4" />
            </div>
          ))}
          {game.platforms.length > 3 && (
            <div className="w-8 h-8 rounded-lg bg-black/50 backdrop-blur flex items-center justify-center text-white/80 text-xs font-bold">
              +{game.platforms.length - 3}
            </div>
          )}
        </div>
      </div>
      <div className="p-6">
        <h3 className="font-gaming text-xl font-bold mb-2 group-hover:text-primary-500 transition-colors">
          {game.title}
        </h3>
        <p className="text-gray-400">{game.tagline}</p>
        {game.rating && (
          <div className="mt-3 flex items-center gap-2">
            <span className="text-yellow-400">★</span>
            <span className="text-sm text-gray-400">{game.rating}</span>
          </div>
        )}
      </div>
    </Link>
  );
};

const GamesSection = () => {
  return (
    <section id="games" className="py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="section-subtitle text-primary-500">OUR PORTFOLIO</p>
          <h2 className="section-title">
            EXPLORE <span className="text-gradient">GAMES</span>
          </h2>
          <p className="section-description">
            Discover our collection of African-inspired gaming experiences
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredGames.slice(0, 6).map((game, index) => (
            <GameCard key={game.id} game={game} index={index} />
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/games" className="btn-secondary">
            VIEW ALL GAMES
          </Link>
        </div>
      </div>
    </section>
  );
};

export default GamesSection;
